import { NativeModules } from 'react-native';
export const { AudioSoundManagerModule } = NativeModules;
